"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navigateToCollection = navigateToCollection;
exports.navigateToNewEntry = navigateToNewEntry;
exports.navigateToEntry = navigateToEntry;
exports.default = void 0;

var _history = require("history");

const history = (0, _history.createHashHistory)();

function navigateToCollection(collectionName) {
  return history.push(`/collections/${collectionName}`);
}

function navigateToNewEntry(collectionName) {
  return history.replace(`/collections/${collectionName}/new`);
}

function navigateToEntry(collectionName, slug) {
  return history.replace(`/collections/${collectionName}/entries/${slug}`);
}

var _default = history;
exports.default = _default;